import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import BadgeStyle from "components/badges/Badge.module.scss";

export const Diamond = ({size, id, className}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 64 64";
  _attributes.width = _attributes.height = size || 64;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(BadgeStyle["badge"], className);
  } else {
    _attributes.className = BadgeStyle["badge"];
  }

  return (
    <svg {..._attributes}>
      <rect x={0} y={0} width={64} height={64} className={BadgeStyle["badge__canvas"]}/>
      <g>
        <path d="M20.986,31.436l4.412,-0.419l-4.412,-0.419l-0.419,-4.412l-0.419,4.412l-4.412,0.419l4.412,0.419l0.419,4.412l0.419,-4.412Z" className={BadgeStyle["diamond__white"]} />
        <g>
          <path d="M10.012,20.016l51.602,0l-13.711,-12.006l-31.797,0l-13.715,12.012l7.627,0l-0.006,-0.006Z" className={BadgeStyle["diamond__white"]} />
          <path d="M53.989,20.019l-51.605,0l11.444,17.41l18.169,18.571l0.011,-0.016l18.163,-18.558l11.441,-17.395l-7.627,0l0.004,-0.012Z" className={BadgeStyle["diamond__white"]} />
        </g>
        <g opacity="0.5">
          <path d="M23.688,8.001l-4.318,0l-9.355,12.012l13.673,-12.012Z" className={BadgeStyle["diamond__fill1"]} />
          <path d="M29.917,8.001l-6.229,0l2.009,12.012l4.22,-12.012Z" className={BadgeStyle["diamond__white"]} />
          <path d="M38.307,20.012l2.045,-12.012l-8.355,0l6.3,12.012l0.01,0Z" className={BadgeStyle["diamond__fill1"]} />
          <path d="M40.316,8.001l0.034,0l-2.045,12.012l2.011,-12.012Z" className={BadgeStyle["diamond__white"]} />
          <path d="M32.001,8.001l-2.084,0l-4.22,12.012l6.304,-12.012Z" className={BadgeStyle["diamond__fill1"]} />
          <path d="M44.636,8.001l-4.319,0l13.672,12.012l-9.353,-12.012Z" className={BadgeStyle["diamond__fill2"]} />
          <path d="M53.989,20.012l-6.086,-12.007l-3.266,0l9.355,12.012l-0.003,-0.005Z" className={BadgeStyle["diamond__fill3"]} />
          <path d="M10.015,20.012l9.355,-12.012l-3.267,0l-6.088,12.012Z" className={BadgeStyle["diamond__white"]} />
          <path d="M53.988,20.019l-12.327,17.418l-9.647,18.542l18.161,-18.565l3.814,-17.395l-0.001,0Z" className={BadgeStyle["diamond__fill4"]} />
          <path d="M38.305,20.019l-6.3,18.714l0,17.257l0.011,-0.016l9.646,-18.543l-3.357,-17.412Z" className={BadgeStyle["diamond__fill5"]} />
          <path d="M25.699,20.019l-3.352,17.415l9.656,18.563l0,-17.258l-6.304,-18.72Z" className={BadgeStyle["diamond__fill6"]} />
          <path d="M10.016,20.019l3.817,17.41l18.162,18.566l-9.656,-18.564l-12.323,-17.412Z" className={BadgeStyle["diamond__fill7"]} />
          <path d="M2.386,20.019l11.445,17.41l-3.818,-17.41l-7.627,0Z" className={BadgeStyle["diamond__fill8"]} />
          <path d="M41.658,37.433l12.327,-17.418l-15.68,0l3.353,17.418Z" className={BadgeStyle["diamond__fill2"]} />
          <path d="M53.989,20.012l-13.673,-12.012l-2.011,12.012l15.684,0Z" className={BadgeStyle["diamond__fill9"]} />
          <path d="M38.305,20.012l-6.3,-12.012l-6.301,12.012l12.601,0Z" className={BadgeStyle["diamond__fill4"]} />
          <path d="M22.345,37.431l3.351,-17.415l-15.68,0l12.329,17.415Z" className={BadgeStyle["diamond__fill8"]} />
          <path d="M25.697,20.012l-2.009,-12.012l-13.673,12.012l15.682,0Z" className={BadgeStyle["diamond__fill5"]} />
          <path d="M16.106,8.001l-13.715,12.012l7.627,0l6.088,-12.012Z" className={BadgeStyle["diamond__fill5"]} />
          <path d="M61.616,20.013l-13.712,-12.006l6.085,12.006l7.627,0Z" className={BadgeStyle["diamond__fill9"]} />
          <path d="M50.175,37.419l11.441,-17.395l-7.627,0l-3.814,17.395Z" className={BadgeStyle["diamond__fill2"]} />
          <path d="M32.001,38.73l6.3,-18.714l-12.601,0l6.301,18.714Z" className={BadgeStyle["diamond__fill2"]} />
        </g>
        <path d="M42.083,37.852l4.468,-0.425l-4.468,-0.424l-0.425,-4.468l-0.424,4.468l-4.468,0.424l4.468,0.425l0.424,4.468l0.425,-4.468Z" className={BadgeStyle["diamond__white"]} />
        <path d="M25.713,20.313l4.467,-0.424l-4.467,-0.425l-0.425,-4.468l-0.425,4.468l-4.468,0.425l4.468,0.424l0.425,4.468l0.425,-4.468Z" className={BadgeStyle["diamond__white"]} />
        <path d="M17.388,14.333l3.013,-0.286l-3.013,-0.285l-0.287,-3.013l-0.286,3.013l-3.013,0.285l3.013,0.286l0.286,3.014l0.287,-3.014Z" className={BadgeStyle["diamond__white"]} />
      </g>
    </svg>
  );
};

Diamond.defaultProps = {
  size: 64,
  className: "",
  id: ""
};

Diamond.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
